import styled from "styled-components";

export const MainTitle = styled.div`
  color: ${({ theme, emboss }) => {
    if (emboss) {
      return "#FFFFFF;";
    }
    return theme.colors.green;
  }};
  text-shadow : ${({ emboss }) => {
    if (emboss) return "0px 3px 6px #00000077;";
    return "null;";
  }}
  font: normal normal bold 43px/59px Open Sans;
`;

export const SubTitle = styled.div`
  color: ${({ theme, emboss }) => {
    if (emboss) {
      return "#FFFFFF;";
    }
    return theme.colors.darkgrey;
  }};
  font: ${({ emboss }) => {
    if (emboss) {
      return "normal normal bold 25px/22px Open Sans;";
    }
    return "normal normal normal 18px/22px Open Sans;";
  }};
  letter-spacing: 0.74px;
  margin-top: -10px;
`;

export const NapaVersion = styled.div`
  color: #006F35;
  font: normal normal bold 19px/24px Open Sans;
  letter-spacing: 0.74px;
  margin-top: 18px;
  margin-left: 6px;
`;
